(function() {
	'use strict';

	angular.module('quantixApp').controller('RemoveAlertDialogController',
			RemoveAlertDialogController);

	RemoveAlertDialogController.$inject = [ '$scope', '$stateParams',
			'$uibModalInstance', 'alertNameFor', 'controllerModule',
			'AlertService', 'parentAccess', '$timeout', 'companyData',
			'CompanyIndAlertService', 'selectedForAll', 'selectedForAlertList',
			'searchedText', '$window' ];

	function RemoveAlertDialogController($scope, $stateParams,
			$uibModalInstance, alertNameFor, controllerModule, AlertService,
			parentAccess, $timeout, companyData, CompanyIndAlertService,
			selectedForAll, selectedForAlertList, searchedText, $window) {

		$scope.alertTypeName = alertNameFor;
		$scope.alertConfirmMsg = "";
		$scope.error = false;
		$scope.errorMessages = "";
		if (companyData.isCompanyLevel == 'Y') {
			$scope.alertType = 'Company';
			$scope.alertConfirmMsg = "Are you sure you want to Remove Alert for this Company ?";
		} else if (companyData.isIndustryLevel == 'Y') {
			$scope.alertType = 'Industry';
			$scope.alertConfirmMsg = "Are you sure you want to Remove Alert for this Industry ?";
		} else if (companyData.isPortfolioLevel == 'Y') {
			$scope.alertType = 'Portfolio';
			$scope.alertConfirmMsg = "Are you sure you want to Remove Alert for this PortFolio ?";
		}

		$scope.removeAlert = function() {

			var calertdata = {
				companyCode : companyData.companyCode,
				isCompanyLevel : companyData.isCompanyLevel,
				industryId : companyData.industryId,
				isIndustryLevel : companyData.isIndustryLevel,
				portfolioId : companyData.portfolioId,
				isPortfolioLevel : companyData.isPortfolioLevel
			};

			CompanyIndAlertService
					.removeAlert(calertdata)
					.then(
							function(result) {

								if (result.isSuccess == 'true') {
									$scope.issuccess = true;
									$scope.error = false;
									$scope.successMessages = result.message;
									if (controllerModule == 'companyProfile'
											|| controllerModule == 'RatingDetailsController1'
											|| controllerModule == 'RatingListController') {
										parentAccess.removeStatus = true;
										parentAccess.alertAction = 'Set Alert';
										parentAccess.companyAlertFlag = true;
									} else if (controllerModule == 'UserAlertSettingsController' || controllerModule == 'AdvanceSearchController') {
										parentAccess.removeStatus = true;
									} else if (controllerModule == 'industryProfileDetailsController') {
										parentAccess.removeIndAlertStatus = true;
										parentAccess.alertAction = 'Set Alert';
										parentAccess.industryLevelAlertFlag = true;

									} else if (controllerModule == 'PortfolioLandingController') {
										parentAccess.removeportfolioAlertStatus = true;
										parentAccess.alertAction = 'Set Alert';
										parentAccess.portfolioLevelAlertFlag = true;
									}

								} else {
									$scope.error = true;
									$scope.issuccess = false;
									$scope.errorMessages = result.message;
								}

								$timeout(function() {
									$uibModalInstance.dismiss('cancel');
								}, 1000);
							},
							function(response, status, headers, config) {
								$scope.error = true;
								$scope.errorMessage = "Error occured while remove Alert"
								$uibModalInstance.dismiss('cancel');
							});

		}

		$scope.removeAlertForAllAndSelected = function() {

			var calertdata = {
				isEmail : 'N',
				isPlatform : 'Y',
				isSelectAll : selectedForAll,
				isCompanyLevel : companyData.isCompanyLevel,
				isIndustryLevel : companyData.isIndustryLevel,
				isPortfolioLevel : companyData.isPortfolioLevel,
				searchText : searchedText
			};

			if (calertdata.isCompanyLevel == 'Y') {
				calertdata.collectUsingCompanyCodeList = selectedForAlertList;
				calertdata.portfolioLevelAlertList = [];
				calertdata.industryLevelAlertList = [];
			} else if (calertdata.isIndustryLevel == 'Y') {
				calertdata.collectUsingIndustryIdList = selectedForAlertList;
				calertdata.portfolioLevelAlertList = [];
				calertdata.industryLevelAlertList = [];
				calertdata.companyLevelAlertList = [];
			} else if (calertdata.isPortfolioLevel == 'Y') {
				calertdata.collectUsingportFolioIdList = selectedForAlertList;
				calertdata.portfolioLevelAlertList = [];
				calertdata.industryLevelAlertList = [];
				calertdata.companyLevelAlertList = [];
			}

			CompanyIndAlertService
					.removeAlertForSelectedAndAll(calertdata)
					.then(
							function(result) {

								if (result.isSuccess == 'true') {
									$scope.issuccess = true;
									$scope.error = false;
									$scope.successMessages = result.message;
									if (calertdata.isSelectAll == 'Y') {
										alert(result.message);
									}

									if (calertdata.isCompanyLevel == 'Y') {
										parentAccess
												.getUserGeneralCompanyLevelAlertsList();
										parentAccess.filterPageSortChangeCompanyLevelMap = {};

									} else if (calertdata.isIndustryLevel == 'Y') {
										parentAccess
												.getUserGeneralIndustryLevelAlertsList();
									} else if (calertdata.isPortfolioLevel == 'Y') {

										parentAccess
												.getUserGeneralPortfolioLevelAlertsList();
									}
								} else {
									$scope.error = true;
									$scope.issuccess = false;
									$scope.errorMessages = result.message;
								}

								$timeout(function() {
									$uibModalInstance.dismiss('cancel');
								}, 1000);

							},
							function(response, status, headers, config) {
								$scope.error = true;
								$scope.errorMessage = "Error occured while removing alerts  in removeAlertForSelectedAndAll m\c"
								$uibModalInstance.dismiss('cancel');
							});

		}

		$scope.close = function() {
			$uibModalInstance.dismiss('cancel');
		}
	}
})();
